import React from "react";
import { Box } from '@mui/material';
import { useLocation } from 'react-router-dom';
import moment from 'moment-timezone';

import SignalCellularAltIcon from '@mui/icons-material/SignalCellularAlt';
import WifiIcon from '@mui/icons-material/Wifi';
import Battery90Icon from '@mui/icons-material/Battery90';


export default function PhoneHeader() {

  const location = useLocation();

  return (

    <Box sx={{
      textAlign: 'left',
      paddingBottom: '10px',
      fontSize: '0.8em',
      display: 'flex',
      justifyContent: 'space-between',
      userSelect: 'none',
    }}>
      <Box
        sx={{
          color: location.pathname == '/' ||
            location.pathname == '/agree' ||
            location.pathname == '/settings' ||
            location.pathname == '/privacy-statement' ||
            location.pathname == '/home' ? '#FFFFFF' : '000000',
          fontSize: '16px',
        }}
      >
        {/* {new Date().toLocaleTimeString('en-GB', { hour12: false })} */}
        {/* {new moment().format("HH:mm")} */}
        {/* var est_time = moment(). tz('America/New_York'). format('YYYY-MM-DD-HH:mm:ss a');*/}
        {new moment().tz('Europe/London').format('HH:mm')}
      </Box>
      <Box
        sx={{

        }}
      >
        <SignalCellularAltIcon
          sx={{
            paddingRight: '5px',
            color: location.pathname == '/' ||
              location.pathname == '/agree' ||
              location.pathname == '/settings' ||
              location.pathname == '/privacy-statement' ||
              location.pathname == '/home' ? '#FFFFFF' : '000000',
          }}
        />
        <WifiIcon
          sx={{
            paddingRight: '5px',
            color: location.pathname == '/' ||
              location.pathname == '/agree' ||
              location.pathname == '/settings' ||
              location.pathname == '/privacy-statement' ||
              location.pathname == '/home' ? '#FFFFFF' : '000000',
          }} />
        <Battery90Icon
          sx={{
            transform: 'rotate(90deg)',
            color: location.pathname == '/' ||
              location.pathname == '/agree' ||
              location.pathname == '/settings' ||
              location.pathname == '/privacy-statement' ||
              location.pathname == '/home' ? '#FFFFFF' : '000000',
            paddingLeft: '5px',
          }}
        />
      </Box>
    </Box>
  )


}